import React from 'react';
import { Colors, Icon, ProgressBar } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import { useLaunchStrategyContext } from '../../contexts/LaunchStrategyContext';
import * as S from './LaunchStrategyContinueBar.styled';
export const LaunchStrategyContinueBar = () => {
    const { showContinueBar, data, progress, absoluteActiveGuideIndex, totalGuides, openModal, setShowContinueBar, } = useLaunchStrategyContext();
    const title = data.modal.categories[progress.category.index].guides[progress.guide.index].title;
    return (React.createElement(S.Container, { onClick: openModal, "$visible": showContinueBar },
        React.createElement(ProgressBar, { value: absoluteActiveGuideIndex + 1, max: totalGuides, height: 4, barColor: Colors.G300 }),
        React.createElement(S.Content, null,
            React.createElement(S.TextualContent, null,
                React.createElement(S.Label, null, "Continue your launch guide:"),
                React.createElement(S.Title, null, title)),
            React.createElement(S.CloseButton, { title: "Close", onClick: (e) => {
                    e.stopPropagation();
                    setShowContinueBar(false);
                } },
                React.createElement(Icon, { component: CloseIcon, height: 10 })))));
};
